import { SidebarItem } from '@coachhubio/nova-sidebar';
import { useTranslation } from 'react-i18next';

import { StyledLink, StyledMenuSection } from '../LookerDashboardSideBar.styles';
import { SectionIds, SectionProps } from '../utils/dashboardSideBar';

import { useFlags } from '~/lib/featureFlags';

export const HumanLedCoachingMenu = ({ currentSectionIndex }: { currentSectionIndex: string }) => {
  const { t } = useTranslation('Dashboard');
  const {
    showMultiRaterFeedbackPage,
    showInsightsPlus,
    showCoDevHubsPage,
    showImpactPlus,
    showLearningPage,
    showCompanionPage,
    showSurveyResultsPage,
  } = useFlags();

  return (
    <>
      <StyledMenuSection>{t('section.general-insights').toUpperCase()}</StyledMenuSection>
      <StyledLink
        href={SectionProps[SectionIds.OVERVIEW]['href']}
        data-testid={SectionIds.OVERVIEW}
        key={`${SectionIds.OVERVIEW}`}
      >
        <SidebarItem
          active={SectionIds.OVERVIEW === currentSectionIndex}
          Icon={SectionProps[SectionIds.OVERVIEW]['icon']}
        >
          {t(`section.overview`)}
        </SidebarItem>
      </StyledLink>
      <StyledLink
        href={SectionProps[SectionIds.ENGAGEMENT]['href']}
        data-testid={SectionIds.ENGAGEMENT}
        key={`${SectionIds.ENGAGEMENT}`}
      >
        <SidebarItem
          active={SectionIds.ENGAGEMENT === currentSectionIndex}
          Icon={SectionProps[SectionIds.ENGAGEMENT]['icon']}
        >
          {t(`section.engagement`)}
        </SidebarItem>
      </StyledLink>
      <StyledLink
        href={SectionProps[SectionIds.SATISFACTION]['href']}
        data-testid={SectionIds.SATISFACTION}
        key={`${SectionIds.SATISFACTION}`}
      >
        <SidebarItem
          active={SectionIds.SATISFACTION === currentSectionIndex}
          Icon={SectionProps[SectionIds.SATISFACTION]['icon']}
        >
          {t(`section.satisfaction`)}
        </SidebarItem>
      </StyledLink>
      <StyledLink
        href={SectionProps[SectionIds.IMPACT]['href']}
        data-testid={SectionIds.IMPACT}
        key={`${SectionIds.IMPACT}`}
      >
        <SidebarItem active={SectionIds.IMPACT === currentSectionIndex} Icon={SectionProps[SectionIds.IMPACT]['icon']}>
          {t(`section.impact`)}
        </SidebarItem>
      </StyledLink>
      {showMultiRaterFeedbackPage || showImpactPlus || showSurveyResultsPage ? (
        <>
          <StyledMenuSection>{t('section.coachhub-feedback-new')}</StyledMenuSection>
        </>
      ) : null}
      {showMultiRaterFeedbackPage ? (
        <StyledLink
          href={SectionProps[SectionIds.MULTI_RATER_FEEDBACK]['href']}
          data-testid={SectionIds.MULTI_RATER_FEEDBACK}
          key={`multirating-feedback`}
        >
          <SidebarItem
            active={SectionIds.MULTI_RATER_FEEDBACK === currentSectionIndex}
            Icon={SectionProps[SectionIds.MULTI_RATER_FEEDBACK]['icon']}
          >
            {t(`section.completion-status`)}
          </SidebarItem>
        </StyledLink>
      ) : null}
      {showImpactPlus ? (
        <StyledLink
          href={SectionProps[SectionIds.IMPACTPLUS]['href']}
          data-testid={SectionIds.IMPACTPLUS}
          key={SectionIds.IMPACTPLUS}
        >
          <SidebarItem
            active={SectionIds.IMPACTPLUS === currentSectionIndex}
            Icon={SectionProps[SectionIds.IMPACTPLUS]['icon']}
          >
            {t(`section.impactPlus`)}
          </SidebarItem>
        </StyledLink>
      ) : null}
      {showSurveyResultsPage ? (
        <StyledLink
          href={SectionProps[SectionIds.SURVEY_RESULTS]['href']}
          data-testid={SectionIds.SURVEY_RESULTS}
          key={SectionIds.SURVEY_RESULTS}
        >
          <SidebarItem
            active={SectionIds.SURVEY_RESULTS === currentSectionIndex}
            Icon={SectionProps[SectionIds.SURVEY_RESULTS]['icon']}
          >
            {t(`section.surveyResults`)}
          </SidebarItem>
        </StyledLink>
      ) : null}
      {showInsightsPlus || showCoDevHubsPage || showLearningPage || showCompanionPage ? (
        <>
          <StyledMenuSection>{t('section.additional-insights').toUpperCase()}</StyledMenuSection>
        </>
      ) : null}
      {showInsightsPlus ? (
        <StyledLink
          href={SectionProps[SectionIds.INSIGHTSPLUS]['href']}
          data-testid={SectionIds.INSIGHTSPLUS}
          key={SectionIds.INSIGHTSPLUS}
        >
          <SidebarItem
            active={SectionIds.INSIGHTSPLUS === currentSectionIndex}
            Icon={SectionProps[SectionIds.INSIGHTSPLUS]['icon']}
          >
            {t(`section.insightsplus`)}
          </SidebarItem>
        </StyledLink>
      ) : null}
      {showCoDevHubsPage ? (
        <StyledLink
          href={SectionProps[SectionIds.CODEVHUBS]['href']}
          data-testid={SectionIds.CODEVHUBS}
          key={SectionIds.CODEVHUBS}
        >
          <SidebarItem
            active={SectionIds.CODEVHUBS === currentSectionIndex}
            Icon={SectionProps[SectionIds.CODEVHUBS]['icon']}
          >
            {t(`section.codevhubs`)}
          </SidebarItem>
        </StyledLink>
      ) : null}
      {showLearningPage ? (
        <StyledLink
          href={SectionProps[SectionIds.LEARNING]['href']}
          data-testid={SectionIds.LEARNING}
          key={SectionIds.LEARNING}
        >
          <SidebarItem
            active={SectionIds.LEARNING === currentSectionIndex}
            Icon={SectionProps[SectionIds.LEARNING]['icon']}
          >
            {t(`section.learning`)}
          </SidebarItem>
        </StyledLink>
      ) : null}
      {showCompanionPage ? (
        <StyledLink
          href={SectionProps[SectionIds.COMPANION]['href']}
          data-testid={SectionIds.COMPANION}
          key={SectionIds.COMPANION}
        >
          <SidebarItem
            active={SectionIds.COMPANION === currentSectionIndex}
            Icon={SectionProps[SectionIds.COMPANION]['icon']}
          >
            {t(`section.companion`)}
          </SidebarItem>
        </StyledLink>
      ) : null}
    </>
  );
};
